export const id = "haagbrown_app";
export const author = "Gateway Apps, LLC";
export const version = "4.2.7";
export const buildId = "4.2.7-tags/4.2.7.1191";
export const commit = "b035ab5";
export const buildTime = 1788901842727;
export const parcelProjectId = "5b1ebca99b969e09255b1ac8";
export const isProduction = true;